// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3TDQq","list":"BalanceDue_list__1JYJS","listRow":"BalanceDue_listRow__1XB2Q","total":"BalanceDue_total__1_WHs"};